// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { Holding } from '@daml.js/utility-registry-holding-v0/lib/Utility/Registry/Holding/V0/Holding';
import { useLedgerApiClient } from '../../../contexts/LedgerApiContext';
import { useParties } from '../../../contexts/PartiesContext';
import TemplateContract from '../../../utils/TemplateContract';
import { useQueryWithOptions } from '../../other/useQueryWithOptions';

const useHoldings: () => UseQueryResult<TemplateContract<Holding>[], string> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();
  return useQueryWithOptions({
    queryKey: ['queryHoldings', operator],
    enabled: !!operator,
    queryFn: async (_, options) => {
      return ledgerApi.queryHoldings(options, operator);
    },
  });
};

export default useHoldings;
